import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../utils/api";

const requestJSON = async (path, options = {}) => {
  const res = await apiRequest(path, options);

  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      const firstFieldError = data && typeof data === "object"
        ? Object.values(data).flat().find((value) => typeof value === "string")
        : null;
      msg = data?.detail || data?.error || firstFieldError || msg;
    } catch {}
    throw new Error(msg);
  }

  if (res.status === 204) return null;
  return res.json();
};

export const fetchCrewPayments = createAsyncThunk("payments/fetchCrewPayments", async () => {
  const data = await requestJSON("/crew-payments/");
  return Array.isArray(data) ? data : data.results || [];
});

export const createCrewPayment = createAsyncThunk("payments/createCrewPayment", async (payload) =>
  requestJSON("/crew-payments/", {
    method: "POST",
    body: JSON.stringify(payload),
  })
);

export const updateCrewPayment = createAsyncThunk("payments/updateCrewPayment", async ({ id, data }) =>
  requestJSON(`/crew-payments/${id}/`, {
    method: "PATCH",
    body: JSON.stringify(data),
  })
);

export const deleteCrewPayment = createAsyncThunk("payments/deleteCrewPayment", async (id) => {
  await requestJSON(`/crew-payments/${id}/`, { method: "DELETE" });
  return id;
});

const replaceById = (list, item) => list.map((row) => (row.id === item.id ? item : row));

const paymentsSlice = createSlice({
  name: "payments",
  initialState: {
    list: [],
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCrewPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCrewPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCrewPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to load payments";
      })
      .addCase(createCrewPayment.pending, (state) => {
        state.saving = true;
      })
      .addCase(createCrewPayment.fulfilled, (state, action) => {
        state.saving = false;
        state.list.unshift(action.payload);
      })
      .addCase(createCrewPayment.rejected, (state, action) => {
        state.saving = false;
        state.error = action.error?.message || "Failed to create payment";
      })
      .addCase(updateCrewPayment.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateCrewPayment.fulfilled, (state, action) => {
        state.saving = false;
        state.list = replaceById(state.list, action.payload);
      })
      .addCase(updateCrewPayment.rejected, (state, action) => {
        state.saving = false;
        state.error = action.error?.message || "Failed to update payment";
      })
      .addCase(deleteCrewPayment.fulfilled, (state, action) => {
        state.list = state.list.filter((row) => row.id !== action.payload);
      });
  },
});

export default paymentsSlice.reducer;
export const selectCrewPayments = (state) => state.payments.list || [];
